import React from 'react';
import { Check } from 'lucide-react';

export default function Checkbox({ selected = false, className = '' }) {
  return (
    <div
      className={`md:w-10 md:h-10 w-4 h-4 rounded border-[3px] flex items-center justify-center transition-all outline-none ring-0 ${selected
        ? 'bg-boonsOrange border-boonsOrange ring-offset-2 ring-offset-boonsOrange'
        : 'border-[#9A9EA6] bg-white'
        } ${className}`}
    >
      {selected && (
        <Check className="md:w-5 md:h-5 w-3 h-3 text-white bg-boonsOrange border-boonsOrange  ring-offset-2 ring-offset-boonsOrange" strokeWidth={3} />
      )}
    </div>
  );
}
